export const GET_FORUMS = 'GET_FORUMS' as const;
export const GET_FORUMS_FULFILLED = 'GET_FORUMS_FULFILLED' as const;
export const GET_FORUMS_PENDING = 'GET_FORUMS_PENDING' as const;
export const GET_FORUMS_REJECTED = 'GET_FORUMS_REJECTED' as const;
export const GET_FORUM_CHART = 'GET_FORUM_CHART' as const;
export const GET_FORUM_CHART_FULFILLED = 'GET_FORUM_CHART_FULFILLED' as const;
export const GET_FORUM_CHART_PENDING = 'GET_FORUM_CHART_PENDING' as const;
export const GET_FORUM_CHART_REJECTED = 'GET_FORUM_CHART_REJECTED' as const;
export const GET_FORUM_GENDER_RATIO = 'GET_FORUM_GENDER_RATIO' as const;
export const GET_FORUM_GENDER_RATIO_FULFILLED = 'GET_FORUM_GENDER_RATIO_FULFILLED' as const;
export const GET_FORUM_GENDER_RATIO_PENDING = 'GET_FORUM_GENDER_RATIO_PENDING' as const;
export const GET_FORUM_GENDER_RATIO_REJECTED = 'GET_FORUM_GENDER_RATIO_REJECTED' as const;
export const GET_FORUM_HOT_POSTS = 'GET_FORUM_HOT_POSTS' as const;
export const GET_FORUM_HOT_POSTS_FULFILLED = 'GET_FORUM_HOT_POSTS_FULFILLED' as const;
export const GET_FORUM_HOT_POSTS_PENDING = 'GET_FORUM_HOT_POSTS_PENDING' as const;
export const GET_FORUM_HOT_POSTS_REJECTED = 'GET_FORUM_HOT_POSTS_REJECTED' as const;
export const GET_FORUM_INFO = 'GET_FORUM_INFO' as const;
export const GET_FORUM_INFO_FULFILLED = 'GET_FORUM_INFO_FULFILLED' as const;
export const GET_FORUM_INFO_PENDING = 'GET_FORUM_INFO_PENDING' as const;
export const GET_FORUM_INFO_REJECTED = 'GET_FORUM_INFO_REJECTED' as const;
export const GET_FORUM_POSTS = 'GET_FORUM_POSTS' as const;
export const GET_FORUM_POSTS_FULFILLED = 'GET_FORUM_POSTS_FULFILLED' as const;
export const GET_FORUM_POSTS_PENDING = 'GET_FORUM_POSTS_PENDING' as const;
export const GET_FORUM_POSTS_REJECTED = 'GET_FORUM_POSTS_REJECTED' as const;
export const GET_FORUM_SCHOOLS = 'GET_FORUM_SCHOOLS' as const;
export const GET_FORUM_SCHOOLS_FULFILLED = 'GET_FORUM_SCHOOLS_FULFILLED' as const;
export const GET_FORUM_SCHOOLS_PENDING = 'GET_FORUM_SCHOOLS_PENDING' as const;
export const GET_FORUM_SCHOOLS_REJECTED = 'GET_FORUM_SCHOOLS_REJECTED' as const;
export const GET_FORUM_SUBSCRIPTION_COUNTS = 'GET_FORUM_SUBSCRIPTION_COUNTS' as const;
export const GET_FORUM_SUBSCRIPTION_COUNTS_FULFILLED = 'GET_FORUM_SUBSCRIPTION_COUNTS_FULFILLED' as const;
export const GET_FORUM_SUBSCRIPTION_COUNTS_PENDING = 'GET_FORUM_SUBSCRIPTION_COUNTS_PENDING' as const;
export const GET_FORUM_SUBSCRIPTION_COUNTS_REJECTED = 'GET_FORUM_SUBSCRIPTION_COUNTS_REJECTED' as const;
export const GET_FORUM_TOPICS = 'GET_FORUM_TOPICS' as const;
export const GET_FORUM_TOPICS_FULFILLED = 'GET_FORUM_TOPICS_FULFILLED' as const;
export const GET_FORUM_TOPICS_PENDING = 'GET_FORUM_TOPICS_PENDING' as const;
export const GET_FORUM_TOPICS_REJECTED = 'GET_FORUM_TOPICS_REJECTED' as const;
export const GET_FORUM_TRENDS = 'GET_FORUM_TRENDS' as const;
export const GET_FORUM_TRENDS_FULFILLED = 'GET_FORUM_TRENDS_FULFILLED' as const;
export const GET_FORUM_TRENDS_PENDING = 'GET_FORUM_TRENDS_PENDING' as const;
export const GET_FORUM_TRENDS_REJECTED = 'GET_FORUM_TRENDS_REJECTED' as const;
